import type { HelpFile } from '../../types/help'
import { PropertyPanelTestIds } from '../../../testids/PropertyPanelTestIds'

export const propertyPanelHelp: HelpFile = {
  docPage: '/docs/admin/form-layout-designer',
  texts: {
    [PropertyPanelTestIds.cardTitleProperties]:
      'Eigenschaften des aktuell ausgewählten Elements im Formularlayout-Designer.',
    [PropertyPanelTestIds.propertyPanelCloseBtn]: null,
  },
}
